export const calculateProductsTotal = (basket) => {
    return basket?.productItems?.reduce(
        (acc, product) => acc + product?.price,
        0
    )
}
export const calculateTotalTax = (basket) => {
    return basket?.productItems?.reduce(
        (acc, product) => acc + (product?.adjustedTax || product?.tax),
        0
    )
}
